import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class MakezmiaStickyPurchase extends Component {
  #abort;
  connectedCallback() {
    super.connectedCallback();
    this.#abort = new AbortController();
    const section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
    section?.addEventListener(ThemeEvents.variantUpdate, this.updateVariant, {signal:this.#abort.signal});
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abort?.abort();
  }
  updateVariant = event => {
    if (String(event.detail.data.productId) !== this.dataset.productId && !event.detail.data.newProduct) return;
    const price = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    if (price) this.refs.prices.replaceChildren(price.cloneNode(true));
    this.refs.submitButton.disabled = !event.detail.resource?.available;
    this.refs.submitButton.textContent = this.refs.submitButton.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
    this.refs.selection.textContent = event.detail.resource?.title === 'Default Title' ? '' : event.detail.resource?.title || '';
  };
  addToCart() {
    const section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
    const button = section?.querySelector('.buy-buttons-block button[name="add"]');
    if (button && !button.disabled) button.click();
  }
}
if (!customElements.get('mkz-sticky-purchase')) customElements.define('mkz-sticky-purchase', MakezmiaStickyPurchase);
